import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SummaryState } from './summary.model';

export const SUMMARY_FEATURE_KEY = 'summary';

export const getSummaryState = createFeatureSelector<SummaryState>(SUMMARY_FEATURE_KEY);
export const getSummaryAccounts = createSelector(getSummaryState, ({ accounts }) => accounts);
export const getTotalCost = createSelector(getSummaryState, ({ totalCost }) => totalCost);
export const getSummaryOffers = createSelector(getSummaryState, ({ offers }) => offers);
